module.exports = __webpack_public_path__ + "img/natural-beauty.6e726fd0.png";